module.exports = __webpack_public_path__ + "fa-brands-400.f2594ef62455697f61dc.eot";


//////////////////
// WEBPACK FOOTER
// /app/frontend/src/assets/fontawesome/webfonts/fa-brands-400.eot
// module id = ../../../../../src/assets/fontawesome/webfonts/fa-brands-400.eot
// module chunks = styles